import  * as enums from './enum'

export function replaceHttps(url) {
  if(location.protocol == 'https:') {
    const httpsUrl = url.replace('http:','https:');
    return httpsUrl
  }else {
    return url
  }
}

export function toList(m, label = "name", value = "id") {
  if (!m || !enums[m]) {
    return [];
  }
  const obj = enums[m];
  return Object.keys(obj).map(function (i) {
    return { [value]: i, [label]: obj[i] };
  });
}